import React from 'react';
// import PropTypes from 'prop-types'
import default_logo from 'assets/img/logo.svg';
import inverted_logo from 'assets/img/logo-inverted.svg';
import { AppContext } from 'modules/auth/context';

function Footer() {
  const appContext = React.useContext(AppContext);
  return (
    <div className="flex justify-between items-center">
      <div>
        <img
          className="h-4"
          src={appContext?.theme === 'Dark' ? inverted_logo : default_logo}
          alt="GameBox"
        />
      </div>
      <div className="text-xs text-gray-700 font-light text-right">
        2021 GameBox Inc. All rights reserved
      </div>
    </div>
  );
}

Footer.propTypes = {};

export default Footer;
